import React from 'react';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
// import Breadcrumb from 'react-bootstrap/Breadcrumb';
// import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FormattedNumber } from 'react-intl';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import XBadge from '../lib/XBadge';
import Loading from '../common/Loading';
import CardTitleContainer from '../lib/CardTitleContainer';
import Analytics from '../common/Analytics';
import IntegrationGuide from '../common/IntegrationGuide';
import SponsorContainer from '../sponsorship/SponsorContainer';
import AccountTag from '../lib/AccountTag';
import AccountIcon from '../lib/AccountIcon';
import MPTokenTag from '../lib/MPTokenTag';
// import Callout from '../lib/Callout';

class MPTokenIndex extends React.Component {
	constructor() {
		super();

		this.state = {
            mptokens: [],
			loading: false,
		}
		this.fetchMPTokens = this.fetchMPTokens.bind(this);
	}

	componentDidMount() {
        this.fetchMPTokens();
        Analytics.pageview();
	}

	fetchMPTokens() {
		this.setState({ loading: true })
		fetch(`${XRPSCAN_API_URL}/mptokens?sort=score&limit=500`)
			.then(handleResponse)
			.then((data) => {
				this.setState({
					mptokens: data || [],
					loading: false,
				});
			})
			.catch((error) => {
				this.setState({
					loading: false,
				});
			});
	}

	render() {
		const {
            mptokens,
            loading,
		} = this.state;

		// render only loading component if loading state is set to true
		if (loading) {
			return <Loading />
		}

		return (
			<div>
				<Helmet>
					<title>XRP Tokens directory | XRPSCAN</title>
				</Helmet>
				<Row>
					<Col>
						<IntegrationGuide/>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={12}>
						<SponsorContainer />
					</Col>
				</Row>
				{/* <Row>
					<Col xs={12} md={12}>
						<Breadcrumb>
							<LinkContainer to={`/`}><Breadcrumb.Item>Home</Breadcrumb.Item></LinkContainer>
							<Breadcrumb.Item active>Tokens</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
				</Row> */}

				{/* <Row>
				  <Col xs={12} md={12}>
				    <TextAd/>
					</Col>
				</Row> */}

				<Card>
					<Card.Body>
						<Card.Title>
							<CardTitleContainer icon="server" title="Multi-Purpose Tokens directory" />
						</Card.Title>
						{/* <Callout title="MPTOKEN RANKING" variant="info">
							<span className='ml-1'>
								Showing top 500 tokens. Tokens are ranked by their token score. Our token
								ranking algorithm considers metrics such as trustlines, holders,
								supply, price, marketcap etc.&nbsp;
								<a href="https://docs.xrpscan.com/api-documentation/token/token-ranking" target="_blank" rel="noopener noreferrer nofollow">Read more &rarr;</a>
							</span>
						</Callout> */}
						<Table responsive>
							<thead>
								<tr>
									<th className="text-right">#</th>
									<th className="text-left">Ticker</th>
									<th className="text-left">Name</th>
									<th className="text-left">Issuer</th>
									<th className="text-left">Asset class</th>
									<th className="text-right">Distributed</th>
									<th className="text-right">Max Amount</th>
								</tr>
							</thead>
							<tbody>
								{ mptokens.map((mpt, index) => (
								<tr key={index}>
									<td className="text-right"><span>{index+1}</span></td>

									<td className="text-left text-monospace">
                                    { mpt?.Ticker &&
                                        <XBadge variant="primary">
    										<Link to={`/mpt/${mpt?.mpt_issuance_id}`}>
                                                ${mpt?.Ticker}
		    								</Link>
                                        </XBadge>
                                    }
                                    { !mpt?.Ticker &&
                                        <Link to={`/mpt/${mpt?.mpt_issuance_id}`}>
                                            <span className='address-tag'>
                                                {mpt?.mpt_issuance_id}
                                            </span>
                                        </Link>
                                    }
                                    </td>

									<td className="text-left text-nowrap">
                                        <span className=''>
                                            {mpt?.MPTokenMetadataJSON?.name}
                                        </span>
									</td>

									<td className="text-left text-nowrap">
                                        <AccountIcon twitter={mpt?.IssuingAccount?.twitter} />
                                        <span className='address-tag'>
                                            <AccountTag name={mpt?.IssuingAccount} link={true}>{mpt.Issuer}</AccountTag>
                                        </span>
									</td>

									<td className="text-left text-nowrap">
                                        { mpt?.MPTokenMetadataJSON?.asset_class && <span className='text-uppercase mr-2'><XBadge variant="info">{mpt?.MPTokenMetadataJSON?.asset_class}</XBadge></span> }
									</td>

									<td className="text-right text-muteda">
                                    { mpt?.OutstandingAmount >= 0 &&
                                        <span className='text-monospace'>
                                            <FormattedNumber value={(mpt.OutstandingAmount / mpt.MaximumAmount) * 100} minimumFractionDigits={0} maximumFractionDigits={2} />%
                                        </span>
                                    }
									</td>

									<td className="text-right text-muted">
                                        <MPTokenTag
                                            mpt_issuance_id={mpt?.mpt_issuance_id}
                                            AssetScale={mpt?.AssetScale}
                                            Ticker={mpt?.Ticker}
                                        >
                                            {mpt.MaximumAmount}
                                        </MPTokenTag>
									</td>
								</tr>	
								))}
							</tbody>
						</Table>
					</Card.Body>
				</Card>
			</div>
		);		
	}
}

export default MPTokenIndex;